import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil, Subscription } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { VenueService } from "../../../services/venues/venue.service";
import { Location } from '@angular/common';
import { DivisionMenuItemModel } from "../../../models/dashboard/division-menu-item.model";
import { MenuService } from "../../../services/menus/menu.service";
import { AuthenticationService } from "../../../../share-modul/services/authentication/authentication.service";
import { UserModel } from "../../../../share-modul/models/user/user.model";
import {
  CurrentVenueHelperService
} from "../../../../share-modul/services/current-venue-helper/current-venue.helper.service";

@Component({
  selector: 'app-division-menu-details',
  templateUrl: './division-menu-details.component.html',
  styleUrls: ['./division-menu-details.component.scss']
})
export class DivisionMenuDetailsComponent implements OnInit, OnDestroy {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public spinner: boolean;
  public divisionId: string;
  public venueId: string | null;
  public selectedDate: any;
  public menuItems: Array<DivisionMenuItemModel> = new Array<DivisionMenuItemModel>();
  public venueIdUpdateSubscription: Subscription;
  public user: UserModel;
  public currency: string;

  constructor(
    public route: ActivatedRoute,
    private venueService: VenueService,
    private menuService: MenuService,
    private authService: AuthenticationService,
    public router: Router,
    public location: Location,
    public currentVenueHelper: CurrentVenueHelperService
  ) {
  }

  public ngOnInit(): void {
    this.authService.loginUser.subscribe(res => {
      this.user = res!;
    });
    this.route.queryParams.subscribe(async params => {
      this.selectedDate = params['date'];
    });
    this.route.params.subscribe(async params => {
      this.divisionId = params['id'];
      this.venueId = params['venue-id'];
      this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
      this.loadMenuItemsByDivision();
      this.getDefaultCurrency();
    });
  }
  //#endregion

  //#region Public Methods
  public loadMenuItemsByDivision(): void {
    this.menuItems = new Array<DivisionMenuItemModel>();
    this.spinner = true;
    this.venueService.getMenuItemsForDivision(this.divisionId,this.selectedDate)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.menuItems = response;
          this.spinner = false;
        },
        error: _ => {
          this.spinner = false;
        }
      });
  }

  public getDefaultCurrency(): void {
    let companyId = this.authService.getCompanyId();
    this.menuService.getDefaultCurrency(companyId, this.user.roles)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.currency = response.symbol;
        }
      });
  }

  public goBack(): void {
    this.location.back();
  }
  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }

}
